import React, { Component } from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import Rte from "../atoms/rte";

export class MyMap extends Component {
  constructor(props) {
    super(props);

    this.location = this.props?.location;
    this.markerText = this.props?.markerText;
    this.zoom = this.props?.zoom;
  }

  state = {
    showingInfoWindow: false, // Hides or shows the InfoWindow
    activeMarker: {}, // Shows the active marker upon click
    selectedPlace: {}, // Shows the InfoWindow to the selected place upon a marker
  };

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });

  onClose = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  render() {
    return (
      <Map google={this.props.google} zoom={this.zoom} initialCenter={{lat: this.location?.lat, lng: this.location?.lon }}>
        <Marker onClick={this.onMarkerClick} title={"The marker`s title will appear as a tooltip."} address={this.markerText} position={{ lat: this.location?.lat, lng: this.location?.lon }} />
        <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow} onClose={this.onClose}>
          <div>
            <Rte content={this.state?.selectedPlace.address} />
          </div>
        </InfoWindow>
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.GATSBY_GOOGLE_API_KEY,
})(MyMap);
